import script from "./yijii-2.vue?vue&type=script&setup=true&lang=js"
export * from "./yijii-2.vue?vue&type=script&setup=true&lang=js"

import "./yijii-2.vue?vue&type=style&index=0&id=43ddf482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43ddf482"]])

export default __exports__